import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Select, Space, Spin } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import { Add, Clear, Delete, OpenInFull, Refresh } from '@mui/icons-material';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import { FormProvider, useForm } from 'react-hook-form';
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchInput from '../../../SearchInput';
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ShowFile from '../../../ShowFile';
import InputForm from '../../../InputT';

interface SelectData {
  value: string,
  label: string,
}


let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }


function Tab2(props: { form?: any }) {
  const [garantie, SetGarantie] = React.useState<SelectData[]>([]);
  const [Donnee, setDonnee] = React.useState<DataTypeTable[]>([]);
  //const [pageIsLoad, setPageIsLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [valeur, setvaleur] = useState<string>();
  const [montant, setMontant] = useState<number>(0);
  const [pourcentage, setPourcentage] = useState<number>(0);
  const [valeursDeGarantie, setValeursDeGarantie] = useState<number>(0)

  // USER TOKEN
  const authHeader = useAuthHeader()

  // if(localStorage.length == 0){
  //   setDonnee([])
  // }

  const columns: ColumnsType<DataTypeTable> = [
    {
      title: 'Code Garantie',
      dataIndex: 'codgar',
    },
    {
      title: 'N° Identification',
      dataIndex: 'NUMIDENTI',
    },
    {
      title: 'Type Garantie',
      dataIndex: 'typgar',
    },
    {
      title: 'Localisation',
      dataIndex: 'LOCAL',
    },
    {
      title: 'Valeur Garantie',
      dataIndex: 'VALGARANTI',
    },
    {
      title: 'Valeur Couvert',
      dataIndex: 'valCouvert',
    },
    {
      title: 'Désignation',
      dataIndex: 'DESIGNATION',
    },
    {
      title: 'Date Début',
      dataIndex: 'DATDEB',
    },
    {
      title: 'Date Fin',
      dataIndex: 'DATFIN',
    },
    {
      title: 'Commentaire',
      dataIndex: 'TEXTCOMMEN',
    },
    {
      title: 'Fichier',
      key: 'view',
      render: (_, record) => (
        record.fichier ?
          <Space size="middle">
            <Tooltip title='Ouvrir le fichier'>
              <ShowFile file={record.fichier} fileName={record.codgar + '-' + record.NUMCLI + '-' + record.DESIGNATION} />
            </Tooltip>
          </Space>
          :
          "No file"
      ),
    },
    
  ];

  //   const columns: ColumnsType<DataType> = [
  //   {
  //     title: 'Numéro Indice',
  //     dataIndex: 'CODUTI',
  //     key: 'codeUser',
  //     render: (text) => <a>{text}</a>,
  //   },
  //   {
  //     title: 'Valeur Garantie',
  //     dataIndex: 'CODAGE',
  //     key: 'codeAgence',
  //   },
  //   {
  //     title: 'Numéro Compte',
  //     dataIndex: 'CODGROUP',
  //     key: 'codeProfil',
  //   },
  //   {
  //     title: 'Désignation',
  //     dataIndex: 'CODGROUP',
  //     key: 'codeProfil',
  //   },
  //   {
  //     title: 'Date Début',
  //     dataIndex: 'CODGROUP',
  //     key: 'codeProfil',
  //   },
  //   {
  //     title: 'Date Fin',
  //     dataIndex: 'CODGROUP',
  //     key: 'codeProfil',
  //   },
  //   {
  //     title: 'Action',
  //     key: 'action',
  //     render: (_, record) => (
  //       <Space size="middle">
  //         <Tooltip title='Retirer de la liste'>
  //         <Button color='error' icon={<Delete color='error' />} onClick={()=>{
  //           let newRows : DataType[] = [];
  //           //newRows.pop((d)=> d.codage == record.codage && d.codgroup == record.codgroup)
  //            Donnee.map((d)=>{
  //             if(!(d.CODAGE == record.CODAGE && d.CODGROUP == record.CODGROUP)){
  //               newRows.push(d)
  //             }
  //           })

  //           setDonnee(newRows)
  //           localStorage.setItem(Data.LocalVariable.userDistanceHabillitation, Crypter.encrypt(JSON.stringify(newRows)))

  //           //localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
  //         }} />
  //         </Tooltip>
  //       </Space>
  //     ),
  //   },
  // ];

  const handleChangeGarantie = (value: string) => {
    let val = value.split('|')
    setvaleur(value);
    setMontant(parseInt(val[1]))
    setPourcentage(100)
  };

  // if(pageIsLoad){
  //     //alert(Data.ApiUrl.authentification)
  //     setPageIsLoad(false)
  // }

  function loadGaranties() {
    try {

      const datat: SelectData[] = [];
      var gats = JSON.parse((Crypter.decrypt(localStorage.getItem("garanties_client") + "")))

      //alert(gats)

      if (gats.length === 0) {
        //console.log("aucun élément ");
        SetGarantie(datat)
      }
      else {
        gats.map((data: DataTypeTable) => {
          //console.log(JSON.stringify(data))
          datat.push({
            value: data.codgar+"|"+data.VALGARANTI,
            label: data.codgar + ' -> ' + data.VALGARANTI + ' XAF',
          });
          SetGarantie(datat);
        })
      }
    } catch (error) {
      //SweetAlert.fire({title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning"})
      setvaleur('')
      SetGarantie([])
    }


  }

  // function add() {
  //   //alert(valeur)
  //   try{
  //     if (valeur) {
  //       let code = valeur.split('|')[0]
  //       let montantGarantie: number = parseInt(valeur.split('|')[1])

  //       if (Donnee.find((d) => d.codgar == code)) {
  //         SweetAlert.fire({ title: "Cette garantie existe déjà", icon: "warning" })
  //       }
  //       else if(montantGarantie >= montant) {
  //         let gats = JSON.parse((Crypter.decrypt(localStorage.getItem("garanties_client") + "")))
  //         let newData = { key: "0", ...gats.find((d: any) => d.codgar == code) }
  //         newData.valCouvert = montant;
  //         setDonnee([...Donnee, newData]);
  //         localStorage.setItem(Data.LocalVariable.garantie, Crypter.encrypt(JSON.stringify([...Donnee, newData])))

  //         setValeursDeGarantie(valeursDeGarantie+montant)
  //         localStorage.setItem(Data.LocalVariable.montantGarantieCouvert, (valeursDeGarantie+montant).toString())
  //         //console.log(Donnee)
  //       }
  //       else{
  //         SweetAlert.fire({ title: "Le montant couvert doit être inférieur ou égale à la valeur de la garantie", icon: "warning" })
  //       }
  //     }
  //     else {
  //       SweetAlert.fire({ title: "Veillez sélectionner les éléments indiqués", icon: "warning" })
  //     }
  //   }
  //   catch(error){
  //   }
  // }

  function loadData() {
    try {
      let data = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.garantie) + ""))
      //alert(JSON.stringify(data))

      let v = 0
      data.map((d: DataTypeTable) => {
        v += d.valCouvert;
      })
      setValeursDeGarantie(v)
      props.form.setFieldValue("montantGarantieCouvert", v)
      setDonnee(data)

    } catch (error) {
      console.log(error)
    }
  }
  setTimeout(() => {
    if (Donnee.length == 0) {
      loadData()
      loadGaranties()
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        SetGarantie([])
        setDonnee([])
        setvaleur("")
        setMontant(0)
        setPourcentage(0)
        setValeursDeGarantie(0)
        localStorage.removeItem(Data.LocalVariable.garantie)
        localStorage.removeItem(Data.LocalVariable.montantGarantieCouvert)
        //localStorage.clear()
      }
    }
    catch (error) { }
  }, .1);

  let searchGarantieForm: Params = { CodeAgence: '', Table: "V_CGARANTIE", Colonne1: "valeur", Colonne2: "DESIGNATION", Colagence: '101', Choix: 22 }

  return (

    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
      <div className='tabItem'>
        <div>
          <Box fontStyle="inherit">
            <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>

              
              <legend>Garanties Pret</legend>
              <div>
                <Table size='small' columns={columns} pagination={{ pageSize: 5, position: ["bottomRight"] }} dataSource={Donnee} />
              </div>
              <InputForm label='Valeur Total de garantie' name='montantGarantieCouvert' disabled={true} type={'number'} />
            </Box>
          </Box>
        </div>
      </div>
    </Spin>
  );
}

export default Tab2;